import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import headerPortalIcon from "@assets/svg/Teal.svg";
import NotificationBell from "@components/Notification/NotificationBell";
import Profile from "@features/Profile/Profile";
import { StatusDropdown, useStatus } from "@features/Status";
import type { RootState } from "@store/store";
import { openProfileCompletionModal } from "@store/slices/modalSlice";
import { PORTAL_HEADER_SHELL_CLASS, PORTAL_HEADER_TITLE_CLASS } from "@constants/portalUiTheme";

const Header = React.memo(() => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { user } = useSelector((state: RootState) => state.user);
	const isProfileComplete = user?.isProfileComplete ?? false;

	const {
		selectedStatus,
		isDropdownOpen,
		isModalOpen,
		pendingStatus,
		dropdownRef,
		handleStatusSelect,
		handleCloseModal,
		handleStatusUpdated,
		toggleDropdown,
		employmentStatuses,
		loadingStatuses,
	} = useStatus(isProfileComplete);

	const handleStatusButtonClick = () => {
		if (!isProfileComplete) {
			dispatch(openProfileCompletionModal());
		} else {
			toggleDropdown();
		}
	};

	return (
		<header className={PORTAL_HEADER_SHELL_CLASS}>
			<div className="flex shrink-0 items-center gap-2.5 sm:gap-3">
				<img
					src={headerPortalIcon}
					alt=""
					className="h-[2.0625rem] w-[2.3125rem] shrink-0"
					aria-hidden
				/>
				<h1 id="project-title" className={PORTAL_HEADER_TITLE_CLASS}>
					{t("projectTitle")}
				</h1>
			</div>
			<div className="flex shrink-0 items-center gap-2 sm:gap-3">
				<StatusDropdown
					selectedStatus={selectedStatus}
					isDropdownOpen={isDropdownOpen}
					dropdownRef={dropdownRef}
					onStatusSelect={handleStatusSelect}
					onToggleDropdown={handleStatusButtonClick}
					isModalOpen={isModalOpen}
					pendingStatus={pendingStatus}
					onCloseModal={handleCloseModal}
					onStatusUpdated={handleStatusUpdated}
					statusOptions={employmentStatuses}
					loadingStatuses={loadingStatuses}
					isProfileComplete={isProfileComplete}
				/>
				<div className="header-action-circle">
					<NotificationBell />
				</div>
				<Profile />
			</div>
		</header>
	);
});

export default Header;
